export const challengeBoostOptions = {
  hideBoost: true,
  disableBoost: true,
  maxGivingPointsPerPost: 0,
};
